import { Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { FinanceService } from '../shared/finance.service';
import { AngularFireDatabase } from 'angularfire2/database';
import 'rxjs/add/operator/toPromise';
import { IOption } from 'ng-select';
import { formatDate } from '@telerik/kendo-intl';
import { PageChangeEvent } from '@progress/kendo-angular-grid';

@Component({
  selector: 'app-finance-account',
  templateUrl: './finance-account.component.html',
  styleUrls: ['./finance-account.component.scss']
})
export class FinanceAccountComponent implements OnInit {

  currentDate = new Date();
  formattedDate = formatDate(this.currentDate, "yyyy/MM/dd");
  isEdit: boolean = false;
  id: any;
  submitted: boolean = false;
  doesExist: boolean = false;
  FinanceAccounts :any;
  FinanceAccountsOriginal = [];
  FundTransfersOriginal = [];
  existsMessage: string;
  dependencyMessage: string;
  dependencyExist: boolean = false;
  from: any;
  name: any;
  accountTypeList: any[];
  lastId = 201900000001;
  users: Array<IOption> = [];
  FinanceAccountsList: Array<IOption> = [];
  public skip1 = 0;
  public skip2 = 0;
  public pageSize = 10;

  @ViewChild('FinanceManageAcc') FinanceManageAcc;
  @ViewChild('FinanceFundTransfer') FinanceFundTransfer;
  @ViewChild('deleteModal') deleteModal;
  FundTransfers: any;
  sameAccountsMsg: string;
  lowBalanceMsg: string;
  showSameAccountsError: boolean = false;
  showLowBalanceMsg: boolean = false;

  constructor(private financeService: FinanceService, private db: AngularFireDatabase) { }

  ngOnInit() {
    this.initilaizeForm();
    this.getAllFinanceAccounts();
    this.getAccountKey();
    this.getAccountTypes();
    this.getAllUsers();
    this.getAllFundTransfers();
  }

  accountsForm: FormGroup;
  fundTransferForm: FormGroup;


  private initilaizeForm() {
    this.accountsForm = new FormGroup({
      accName: new FormControl('', Validators.required),
      accType: new FormControl('', Validators.required),
      accHolder: new FormControl('', Validators.required),
      accAmount: new FormControl('', [Validators.required, Validators.pattern('[0-9]*[\.]?[0-9]{1,2}')]),
      accCreated: new FormControl(),
      accNumber: new FormControl(''),
      id: new FormControl()
    });

    this.fundTransferForm = new FormGroup({
      transferFrom: new FormControl('', Validators.required),
      transferTo: new FormControl('', Validators.required),
      transferAmount: new FormControl('', [Validators.required, Validators.pattern('[0-9]*[\.]?[0-9]{1,2}')]),
      transactionNote: new FormControl(),
      transferFromName: new FormControl(),
      transferToName: new FormControl(),
      id: new FormControl()
    });
  }

  checkExistsWhileAdd(name, field, from) {
    let promise = new Promise((resolve, reject) => {
      return this.financeService.find(name, field, from).once("value").then(res => { // Success
        resolve(res.numChildren());
      });
    });
    return promise;
  }
  showExitsMessage(name, from) {
    this.existsMessage = name + ' already exists in ' + from;
    this.doesExist = true;
  }

  checkDependency(dependentdb, dependentColumnName, dependentValue) {
    let promise = new Promise((resolve, reject) => {
      return this.financeService.checkDependency(dependentdb, dependentColumnName, dependentValue).once("value").then(res => { // Success
        resolve(res.numChildren());
      });
    });
    return promise;
  }

  showDependencyMessage(count, dependentModule, moduleName) {
    this.dependencyMessage = 'Delete Failed !! This ' + moduleName + ' has ' + count + ' dependencies in ' + dependentModule;
    this.dependencyExist = true;
  }

  getAccountTypes() {
    var y: any;
    var accType = this.db.list("financeAccountType");
    accType.snapshotChanges().subscribe(item => {
      this.accountTypeList = [];
      item.forEach(element => {
        y = element.payload.toJSON();
        this.accountTypeList.push({ label: String(y.accTypeName), value: String(y.accTypeName) });
      });
    });
  }

  getAllUsers() {
    this.financeService.getAllUsers().snapshotChanges().subscribe((data) => {
      this.users = [];
      data.forEach(user => {
        this.users.push({ label: user.payload.child("name").val(), value: user.payload.child("name").val() });
      });
    });
  }

  getAccountKey() {
    const d = this.db.list('/financeAccounts', ref => ref.orderByKey().limitToLast(1)).valueChanges();
    d.subscribe(data => {
      data.forEach(d => {
        var year = (String(d["id"])).substring(0, 4);
        var date = new Date();
        var currentYear = date.getFullYear();
        if (year == String(currentYear)) {
          this.lastId = parseInt(d["id"]) + 1;
        } else {
          this.lastId = parseInt(currentYear + "00000000");
        }
      });
    });
  }


  getAllFinanceAccounts() {
    var x = this.financeService.getAllFinanceAccounts();
    x.snapshotChanges().subscribe(item => {
      this.FinanceAccounts = [];
      this.FinanceAccountsList = [];
      this.FinanceAccountsOriginal = [];
      item.forEach(element => {
        this.FinanceAccounts.push({
          "accName": String(element.payload.child("accName").val()),
          "accType": String(element.payload.child("accType").val()),
          "accHolder": String(element.payload.child("accHolder").val()),
          "accAmount": String(element.payload.child("accAmount").val()),
          "accCreated": String(element.payload.child("accCreated").val()),
          "accNumber": String(element.payload.child("accNumber").val()),
          "id": element.key
        });
        this.FinanceAccountsOriginal.push({
          "accName": String(element.payload.child("accName").val()),
          "accType": String(element.payload.child("accType").val()),
          "accHolder": String(element.payload.child("accHolder").val()),
          "accAmount": String(element.payload.child("accAmount").val()),
          "accCreated": String(element.payload.child("accCreated").val()),
          "accNumber": String(element.payload.child("accNumber").val()),
          "id": element.key
        });
        this.FinanceAccountsList.push({ label: String(element.payload.child("accName").val()), value: String(element.key) });
      });
      this.loadItemSearchResult();
    });
  }




  editFinanceAccounts(id) {
    this.isEdit = true;
    this.id = id;
    var x = this.financeService.getFinanceAccounts(id);
    x.once("value").then((FinanceAccounts) => {
      this.accountsForm.get('accName').setValue(FinanceAccounts.child("accName").val(), Validators.required);
      this.accountsForm.get('accType').setValue(FinanceAccounts.child("accType").val(), Validators.required);
      this.accountsForm.get('accHolder').setValue(FinanceAccounts.child("accHolder").val(), Validators.required);
      this.accountsForm.get('accAmount').setValue(FinanceAccounts.child("accAmount").val(), Validators.required);
      this.accountsForm.get('accCreated').setValue(FinanceAccounts.child("accCreated").val(), Validators.required);
      this.accountsForm.get('accNumber').setValue(FinanceAccounts.child("accNumber").val(), Validators.required);
      this.accountsForm.get('id').setValue(id);
    });

    this.FinanceManageAcc.show();
  }

  submitAccounts() {
    var self = this;
    this.submitted = true;
    this.doesExist = false;
    if (this.accountsForm.valid) {
      // var accNumber = this.financeService.getNextKey('financeAccounts','accNumber');
      // console.log("account Number==> "+accNumber);
      this.checkExistsWhileAdd(this.accountsForm.value.accName, 'accName', 'financeAccounts').then((data) => {
        if (data == 0) {
          if (!this.isEdit) {
            this.accountsForm.controls['id'].setValue(self.lastId);
            this.accountsForm.controls['accCreated'].setValue(this.formattedDate);
            this.financeService.addFinanceAccounts(this.accountsForm.value, this.lastId).then(() => {
              this.submitted = false;
              this.accountsForm.reset();
              this.FinanceManageAcc.hide();
            });
          }
          else {
            this.financeService.updateFinanceAccounts(this.accountsForm.value).then(() => {
              this.submitted = false;
              this.isEdit = false;
              this.accountsForm.reset();
              this.FinanceManageAcc.hide();
            });
          }
        }
        else {
          this.showExitsMessage(this.accountsForm.value.accName, 'Account');
        }
      });
    }
  }

  getAllFundTransfers() {
    var x = this.financeService.getAllFundTransfers();
    x.snapshotChanges().subscribe(item => {
      this.FundTransfers = [];
      this.FundTransfersOriginal = [];
      item.forEach(element => {
        this.FundTransfers.push({
          "transferFrom": String(element.payload.child("transferFrom").val()),
          "transferTo": String(element.payload.child("transferTo").val()),
          "transferAmount": String(element.payload.child("transferAmount").val()),
          "transactionNote": String(element.payload.child("transactionNote").val()),
          "transferFromName": String(element.payload.child("transferFromName").val()),
          "transferToName": String(element.payload.child("transferToName").val()),
          "id": element.key
        });
        this.FundTransfersOriginal.push({
          "transferFrom": String(element.payload.child("transferFrom").val()),
          "transferTo": String(element.payload.child("transferTo").val()),
          "transferAmount": String(element.payload.child("transferAmount").val()),
          "transactionNote": String(element.payload.child("transactionNote").val()),
          "transferFromName": String(element.payload.child("transferFromName").val()),
          "transferToName": String(element.payload.child("transferToName").val()),
          "id": element.key
        });
      });
      this.loadItemSearchResultTransfers();
    });
  }

  transferFunds() {
    var self = this;
    this.submitted = true;
    this.doesExist = false;
    this.showLowBalanceMsg = false;
    this.showSameAccountsError = false;
    if (this.fundTransferForm.valid) {
      if (!this.isEdit) {
        if (this.fundTransferForm.value.transferFrom !== this.fundTransferForm.value.transferTo) {
          var from, to;
          var fromKey = this.fundTransferForm.value.transferFrom;
          var toKey = this.fundTransferForm.value.transferTo;
          var transferAmount = this.fundTransferForm.value.transferAmount;

          var x = this.financeService.getFinanceAccounts(fromKey);
          x.once("value").then((FinanceAccount) => {
            from = FinanceAccount.child("accAmount").val();
            this.fundTransferForm.get('transferFromName').setValue(FinanceAccount.child("accName").val());
            var x = this.financeService.getFinanceAccounts(toKey);
            x.once("value").then((FinanceAccount) => {
              to = FinanceAccount.child("accAmount").val();
              this.fundTransferForm.get('transferToName').setValue(FinanceAccount.child("accName").val());

              if (parseFloat(from) >= parseFloat(transferAmount)) {
                var newFromAmount = parseFloat(from) - parseFloat(transferAmount);
                var newToAmount = parseFloat(to) + parseFloat(transferAmount);
                this.fundTransferForm.controls['transactionNote'].setValue("Debited from " + fromKey + " and Credited to " + toKey);
                this.financeService.updateAccounts(fromKey, newFromAmount, toKey, newToAmount).then(() => {
                  this.financeService.addTransferFunds(this.fundTransferForm.value).then(() => {
                    this.submitted = false;
                    this.fundTransferForm.reset();
                    this.FinanceFundTransfer.hide();
                  });
                });

              } else {
                this.lowBalanceMsg = "Transfer Failed! Debit From account does not have sufficient funds";
                this.showLowBalanceMsg = true;
              }
            });
          });

        } else {
          this.sameAccountsMsg = "Transfer Failed! Debit from and Credit to cannot be same accounts";
          this.showSameAccountsError = true;
        }
      }
      // else {
      //   this.financeService.updateFinanceAccounts(this.accountsForm.value).then(() => {
      //     this.submitted = false;
      //     this.isEdit = false;
      //     this.accountsForm.reset();
      //     this.FinanceManageAcc.hide();
      //   });
      // }
    }
  }

  public openDeleteModal(id, name, from): void {
    this.dependencyExist = false;
    this.id = id;
    this.from = from;
    this.name = name;
    this.deleteModal.show();
  }
  public delete(): void {
    switch (this.from) {
      case 'Account':
        //this.checkDependency('financeTransactions', 'categoryName', this.name).then((data) => {
        //if (data == 0) {
        this.financeService.deleteFinanceAccounts(this.id).then(() => {
          this.id = null;
          this.from = null;
          this.deleteModal.hide();
        });
        // } else {
        // this.showDependencyMessage(data, 'Transactions', 'Category');
        //}
        //});
        break;

      // case 'Category Type':
      //   this.checkDependency('financeExpenseCat', 'categoryType', this.name).then((data) => {
      //     if (data == 0) {
      //       this.financeService.deleteCatType(this.id).then(() => {
      //         this.id = null;
      //         this.from = null;
      //         this.deleteModal.hide();
      //       });
      //     } else {
      //       this.showDependencyMessage(data, 'Category', 'Category Type');
      //     }
      //   });
      //   break;

    }
  }

  //FinanceAccounts Load Grid
  loadItemSearchResult() {
  this.FinanceAccounts = {
      data: this.FinanceAccountsOriginal.slice(this.skip1, this.skip1 + this.pageSize),
      total: this.FinanceAccountsOriginal.length
  };

}
public pageChange(event: PageChangeEvent): void {
this.skip1 = event.skip;
this.loadItemSearchResult();
}

//Transfers Load Grid
loadItemSearchResultTransfers() {
  this.FundTransfers = {
      data: this.FundTransfersOriginal.slice(this.skip2, this.skip2 + this.pageSize),
      total: this.FundTransfersOriginal.length
  };

}
public pageChangeTransfers(event: PageChangeEvent): void {
this.skip2 = event.skip;
this.loadItemSearchResultTransfers();
}
}



// WEBPACK FOOTER //
// E:/Office Projects/Paarsel/paarsel_business_web/paarsel_business_web/src/app/finance-management/finance-account/finance-account.component.ts